import Vue from "vue";
import Router from "vue-router";
import beforeEach from "./beforeEach";
import { routes as empresa } from "../app/Empresas";
// import { routes as contabilista } from '../app/Contabilistas'
import { routes as main } from "../app/Main/index";
// import { routes as apuracaoICMS } from '../app/ApuracaoICMS'
import { routes as login } from "../app/Login";
// import { routes as planilhas } from '../app/Planilhas'
// import { routes as impostos } from '../app/Impostos'
import { routes as usuarios } from "../app/Usuarios";
import { routes as trocarSenha } from "../app/TrocarSenha";
import { routes as cartoes } from "../app/Cartoes";
import { routes as energia } from "../app/Energia";
import { routes as destda } from "../app/DeSTDA";
import { routes as certificado } from "../app/Certificado";
import { routes as nfce } from "../app/NFCe";
import { routes as nfse } from "../app/Nfse";
import { routes as movimentos } from "../app/Movimentos";
import { routes as funrural } from "../app/Funrural";
import { routes as rescisao } from "../app/CalculoDeRescisao";
import { routes as extratos } from "../app/ExtratosOFX";
// import { routes as metas } from '../app/Metas'
import { routes as relatorios } from "../app/Relatorios";
import { routes as ncm } from "../app/Ncm/index";
import { routes as PlanosDeContas } from "../app/PlanoDeContas";
import { routes as ApuracaoIRPJ } from "../app/ApuracaoIRPJ";
import { routes as SpedFiscal } from "../app/EfdIcmsIpi";
import { routes as SpedContribuicoes } from "../app/SpedContribuicoes";
// import { routes as nfProdutor } from '../app/NotasDeProdutor'
import { routes as auditoriaSpedContribuicao } from "../app/AuditoriaContribuicoes";
import { routes as sefazCteNfe } from "../app/SefazCteNfe";
import { routes as simplesNacional } from "../app/SimplesNacional/index";
import { routes as auditoriaSpedFiscal } from "../app/AuditoriaSpedFiscal";
import { routes as ricms } from "../app/RICMS";
import { routes as inventarios } from "../app/Inventarios";
// import { routes as telecomunicacoes } from '../app/Telecomunicacoes'
import { routes as fretes } from "../app/Fretes";
import { routes as documentos } from "../app/DocumentosOCR";
import { routes as empresasRfb } from "../app/EmpresasRFB";
import { routes as exportacao } from "../app/Export";

Vue.use(Router);

const router = new Router({
  routes: [
    ...main,
    ...login,
    // Opção Simples
    ...simplesNacional,
    // Opção Cadastros
    // ...contabilista,
    ...empresa,
    ...usuarios,
    ...cartoes,
    // Opções ICMS
    // ...apuracaoICMS,
    // ...destda,
    // ...ricms,
    // Opções Arquivos
    // ...impostos,
    ...certificado,
    ...nfse,
    ...nfce,
    ...sefazCteNfe,
    // ...telecomunicacoes,
    // NCM
    ...ncm,
    // Folha
    ...rescisao,
    ...funrural,
    // Controladoria
    ...energia,
    ...ricms,
    // ...planilhas,
    ...movimentos,
    // Configurações
    ...trocarSenha,
    // Utilitarios
    ...extratos,
    ...inventarios,
    ...relatorios,
    // Contabil
    ...PlanosDeContas,
    ...fretes,
    ...ApuracaoIRPJ,
    // AuditoriaSped
    ...auditoriaSpedFiscal,
    ...auditoriaSpedContribuicao,
    // SPEDS
    ...SpedFiscal,
    ...SpedContribuicoes,
    ...destda,
    // Gerencial
    // ...nfProdutor,
    ...documentos,
    ...empresasRfb,
    ...exportacao
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeResolve(beforeEach);
export default router;
